var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "subheader py-2 py-lg-4",
      class: _vm.subheaderClasses,
      attrs: { id: "kt_subheader" },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap",
          class: {
            "container-fluid": _vm.widthFluid,
            container: !_vm.widthFluid,
          },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-items-center flex-wrap mr-1" },
            [
              _c(
                "h5",
                {
                  staticClass:
                    "text-dark font-weight-bold my-2 mr-5 page-title",
                },
                [_vm._v(" " + _vm._s(_vm.title) + " ")]
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "d-flex align-items-center" },
            [
              _c(
                "b-dropdown",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      value: "Quick actions",
                      expression: "'Quick actions'",
                      modifiers: { hover: true },
                    },
                  ],
                  attrs: {
                    size: "sm",
                    variant: "link",
                    "toggle-class": "custom-v-dropdown",
                    right: "",
                    text: "Christian Jebrail",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "navi navi-hover min-w-md-250px" },
                    [
                      _c(
                        "b-dropdown-text",
                        {
                          staticClass: "navi-header font-weight-bold",
                          attrs: { tag: "div" },
                        },
                        [
                          _vm._v(" Jump to: "),
                          _c("i", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            staticClass: "flaticon2-information",
                            attrs: {
                              "data-toggle": "tooltip",
                              "data-placement": "left",
                              title: "Click to learn more...",
                            },
                          }),
                        ]
                      ),
                      _c("b-dropdown-text", {
                        staticClass: "navi-separator mb-3",
                        attrs: { tag: "div" },
                      }),
                      _c(
                        "b-dropdown-text",
                        { staticClass: "navi-item", attrs: { tag: "div" } },
                        [
                          _c(
                            "a",
                            { staticClass: "navi-link", attrs: { href: "#" } },
                            [
                              _c("span", { staticClass: "navi-icon" }, [
                                _c("i", { staticClass: "flaticon2-drop" }),
                              ]),
                              _c("span", { staticClass: "navi-text" }, [
                                _vm._v("Recent Orders"),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "b-dropdown-text",
                        { staticClass: "navi-item", attrs: { tag: "div" } },
                        [
                          _c(
                            "a",
                            { staticClass: "navi-link", attrs: { href: "#" } },
                            [
                              _c("span", { staticClass: "navi-icon" }, [
                                _c("i", {
                                  staticClass: "flaticon2-calendar-8",
                                }),
                              ]),
                              _c("span", { staticClass: "navi-text" }, [
                                _vm._v("Support Cases"),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "b-dropdown-text",
                        { staticClass: "navi-item", attrs: { tag: "div" } },
                        [
                          _c(
                            "a",
                            { staticClass: "navi-link", attrs: { href: "#" } },
                            [
                              _c("span", { staticClass: "navi-icon" }, [
                                _c("i", {
                                  staticClass: "flaticon2-telegram-logo",
                                }),
                              ]),
                              _c("span", { staticClass: "navi-text" }, [
                                _vm._v("Projects"),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "b-dropdown-text",
                        { staticClass: "navi-item", attrs: { tag: "div" } },
                        [
                          _c(
                            "a",
                            { staticClass: "navi-link", attrs: { href: "#" } },
                            [
                              _c("span", { staticClass: "navi-icon" }, [
                                _c("i", { staticClass: "flaticon2-new-email" }),
                              ]),
                              _c("span", { staticClass: "navi-text" }, [
                                _vm._v("Messages"),
                              ]),
                              _c("span", { staticClass: "navi-label" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "label label-success label-rounded",
                                  },
                                  [_vm._v("5")]
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c("b-dropdown-text", {
                        staticClass: "navi-separator mt-3",
                        attrs: { tag: "div" },
                      }),
                      _c(
                        "b-dropdown-text",
                        { staticClass: "navi-footer", attrs: { tag: "div" } },
                        [
                          _c(
                            "a",
                            {
                              staticClass:
                                "btn btn-light-primary font-weight-bolder btn-sm",
                              attrs: { href: "#" },
                            },
                            [_vm._v("Upgrade plan")]
                          ),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true },
                                },
                              ],
                              staticClass:
                                "btn btn-clean font-weight-bold btn-sm",
                              attrs: {
                                href: "#",
                                "data-toggle": "tooltip",
                                "data-placement": "left",
                                title: "Click to learn more...",
                              },
                            },
                            [_vm._v("Learn more")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }